import { render, staticRenderFns } from "./TrackManagement.vue?vue&type=template&id=0c961d46&scoped=true"
import script from "./TrackManagement.vue?vue&type=script&lang=js"
export * from "./TrackManagement.vue?vue&type=script&lang=js"
import style0 from "./TrackManagement.vue?vue&type=style&index=0&id=0c961d46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c961d46",
  null
  
)

export default component.exports